/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} How_We_Work_Title_2Inputs */

const en_how_we_work_title_2 = /** @type {(inputs: How_We_Work_Title_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`to a system that runs.`)
};

const lv_how_we_work_title_2 = /** @type {(inputs: How_We_Work_Title_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`līdz sistēmai, kas strādā.`)
};

/**
* | output |
* | --- |
* | "to a system that runs." |
*
* @param {How_We_Work_Title_2Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const how_we_work_title_2 = /** @type {((inputs?: How_We_Work_Title_2Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<How_We_Work_Title_2Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_how_we_work_title_2(inputs)
	return en_how_we_work_title_2(inputs)
});